var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"top-header"}},[_c('dv-decoration-8',{staticClass:"header-left-decoration"}),_vm._v(" "),_c('dv-decoration-8',{staticClass:"header-right-decoration",attrs:{"reverse":true}}),_vm._v(" "),_c('div',{staticClass:"center-title"},[_vm._v(_vm._s(_vm.mainTitle)+"农村卫生厕所智能化长效管护平台")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b251162","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dataV/topHeader.vue
// module id = null
// module chunks = 